/**
 * Resolves image URLs to work across different domains.
 * Handles both relative URLs (/api/files/...) and absolute URLs.
 * 
 * @param {string} url - The image URL (relative or absolute)
 * @returns {string} - The resolved URL
 */
export const resolveImageUrl = (url) => {
  if (!url) return '';
  
  // If it's a base64 data URL, return as-is (for legacy data)
  if (url.startsWith('data:')) {
    return url;
  }
  
  // If it's already an absolute URL with http/https, return as-is
  // (for external URLs like stock photos)
  if (url.startsWith('http://') || url.startsWith('https://')) {
    // Check if it's an old preview domain URL that needs to be converted to relative
    const previewDomainPattern = /https?:\/\/[^/]+\.preview\.emergentagent\.com(\/api\/files\/[^/]+)/;
    const match = url.match(previewDomainPattern);
    if (match) {
      // Convert to relative URL
      return match[1];
    }
    return url;
  }
  
  // If it's a relative URL starting with /, it will work as-is
  if (url.startsWith('/')) {
    return url;
  }
  
  // For any other format, prepend /
  return `/${url}`;
};

export default resolveImageUrl;
